import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 18, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 32 32' fill='none' className={className}>
      <g>
        <rect fill='none' height='402' width='582' y='-1' x='-1' />
      </g>
      <g>
        <path
          fill={fillColor}
          d='m29.980633,15.54c-1.93,-5.19 -7.44,-8.54 -13.93,-8.54s-12,3.35 -13.93,8.54a0.92,0.92 0 0 0 -0.07,0.36l0,0.1a0.92,0.92 0 0 0 0.07,0.36c2,5.22 7.48,8.59 14,8.59s11.93,-3.33 13.86,-8.49a0.92,0.92 0 0 0 0.07,-0.36l0,-0.2a0.92,0.92 0 0 0 -0.07,-0.36z'
        />
        <circle fill={theme.colors.grey00_2} r='6' cy='16' cx='16' />
        <path fill={fillColor} d='m14,17a1,1 0 0 1 -1,-1a3,3 0 0 1 3,-3a1,1 0 0 1 0,2a1,1 0 0 0 -1,1a1,1 0 0 1 -1,1z' />
        <path fill={fillColor} d='m3,8a1,1 0 0 1 -1,-1l0,-4a1,1 0 0 1 1,-1l4,0a1,1 0 0 1 0,2l-3,0l0,3a1,1 0 0 1 -1,1z' />
        <path fill={fillColor} d='m29,8a1,1 0 0 1 -1,-1l0,-3l-3,0a1,1 0 0 1 0,-2l4,0a1,1 0 0 1 1,1l0,4a1,1 0 0 1 -1,1z' />
        <path fill={fillColor} d='m7,30l-4,0a1,1 0 0 1 -1,-1l0,-4a1,1 0 0 1 2,0l0,3l3,0a1,1 0 0 1 0,2z' />
        <path fill={fillColor} d='m29,30l-4,0a1,1 0 0 1 0,-2l3,0l0,-3a1,1 0 0 1 2,0l0,4a1,1 0 0 1 -1,1z' />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
